import { Row } from "antd";
import { Wrapper } from "./MultiFASubPage.styled";
import { Button, Input, Spin } from "components/common";
import { useEffect, useState } from "react";
import GoogleAuthModal from "./GoogleAuthModal";
import { message } from "components/common";
import { callGetApiWithAuth, callPostApiWithAuth } from "utils/api";
import { useSelector } from "react-redux";
import Google2FAModal from "components/common/modals/Google2FAModal";

export default function MultiFASubPage() {
  const myUser = useSelector((state) => state.auth.user);

  const [formData, setFormData] = useState({
    authenticator_name: "",
  });
  const [faStatus, setFaStatus] = useState(undefined);
  const [secret, setSecret] = useState("");
  const [qrImage, setQrImage] = useState("");

  const [modal, setModal] = useState(false);
  const [faModal, setFaModal] = useState(false);
  const [mode, setMode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const onGet2FASecret = (res) => {
    setSecret(res.data.secret);
    setQrImage(res.data.qr_image);
    setModal(true);
    setIsLoading(false);
  };

  const onFailGet2FASecret = () => {
    setIsLoading(false);
  };

  const get2FASecret = () => {
    callGetApiWithAuth(
      "my_account/setting/get_2fa_secret?authenticator_name=" +
        formData.authenticator_name,
      onGet2FASecret,
      onFailGet2FASecret
    );
  };
  const onContinue = () => {
    get2FASecret();
    setIsLoading(true);
  };

  const onGetAuthenticatorStatus = (res) => {
    setFaStatus(res.data);
    setStatusLoading(false);
  };

  const getAuthenticatorStatus = () => {
    setStatusLoading(true);
    callGetApiWithAuth(
      "my_account/setting/2fa_status",
      onGetAuthenticatorStatus
    );
  };

  const onDeleteDone = () => {
    getAuthenticatorStatus();
    setFaModal(false);
    setIsLoading(false);
    message.success("2FA Deleted Successfully");
  };

  const onLoginEnableDone = () => {
    getAuthenticatorStatus();
    setFaModal(false);
    setIsLoading(false);
    message.success("Login 2FA Enabled Successfully");
  };

  const onLoginDisableDone = () => {
    getAuthenticatorStatus();
    setIsLoading(false);
    setFaModal(false);
    message.success("Login 2FA Disabled Successfully");
  };

  const delete2FA = (code) => {
    setIsLoading(true);
    callPostApiWithAuth(
      "my_account/setting/delete_2fa",
      {
        code,
      },
      onDeleteDone,
      () => {
        setIsLoading(false);
      }
    );
  };

  const login2FAEnable = (code) => {
    setIsLoading(true);
    callPostApiWithAuth(
      "my_account/setting/enable_login_2fa",
      {
        code,
      },
      onLoginEnableDone,
      () => {
        setIsLoading(false);
      }
    );
  };

  const login2FADisable = (code) => {
    setIsLoading(true);
    callPostApiWithAuth(
      "my_account/setting/disable_login_2fa",
      {
        code,
      },
      onLoginDisableDone,
      () => {
        setIsLoading(false);
      }
    );
  };

  const onDelete = () => {
    setFaModal(true);
    setMode("delete_2fa");
  };

  const onLogin2FAEnable = () => {
    setFaModal(true);
    if (faStatus.is_login_enabled == 1) setMode("login_2fa_disable");
    else setMode("login_2fa_enable");
  };

  useEffect(() => {
    getAuthenticatorStatus();
  }, []);

  return (
    <Wrapper>
      <h2>Google Authenticator Setting</h2>
      {statusLoading && <Spin spinning={true} />}
      {!statusLoading && !faStatus && (
        <>
          <Row>
            <Input
              label="Authenticator Name*"
              value={formData.authenticator_name}
              onChange={(e) =>
                setFormData({ ...formData, authenticator_name: e.target.value })
              }
            />
          </Row>
          <div className="s-container0">
            <div className="change-button">
              <Button onClick={onContinue}>
                {isLoading ? <Spin spinning={true} /> : "Continue"}
              </Button>
            </div>
          </div>
          <GoogleAuthModal
            setModal={setModal}
            visible={modal}
            formData={formData}
            secret={secret}
            qrImage={qrImage}
            getAuthenticatorStatus={getAuthenticatorStatus}
          />
        </>
      )}
      {!statusLoading && faStatus && (
        <>
          <Row>
            <label>Authenticator Name:</label>
            <b> {faStatus.authenticator_name}</b>
          </Row>
          <Row>
            <label>Status:</label>
            <b> Enabled</b>
          </Row>
          <Row>
            <label>Enabled for Login:</label>
            <b> {faStatus.is_login_enabled == 1 ? "Enabled" : "Disabled"}</b>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                gap: "16px",
                width: "100%",
              }}
            >
              <Button onClick={onDelete}>Delete</Button>
              <Button onClick={onLogin2FAEnable}>
                {faStatus.is_login_enabled == 1 ? "Disable" : "Enable"} 2FA for
                login
              </Button>
            </div>
          </Row>
        </>
      )}
      <Google2FAModal
        isLoading={isLoading}
        visible={faModal}
        onCancel={() => setFaModal(false)}
        onSubmit={
          mode == "delete_2fa"
            ? delete2FA
            : mode == "login_2fa_enable"
            ? login2FAEnable
            : login2FADisable
        }
      />
    </Wrapper>
  );
}
